import type { components } from "@/shared/api";

type MatchSummary = components["schemas"]["MatchSummary"];

export type HeroStat = { heroId: number; games: number; wins: number };

// Матчи и победы на каждом герое. Сначала самые частые, при равенстве — у кого больше побед,
// дальше — кого играли последним.
export const heroStats = (matches: readonly MatchSummary[]): HeroStat[] => {
  const stats = new Map<number, HeroStat>();
  for (const match of matches) {
    const stat = stats.get(match.hero_id) ?? { heroId: match.hero_id, games: 0, wins: 0 };
    stat.games += 1;
    stat.wins += match.won ? 1 : 0;
    stats.set(match.hero_id, stat);
  }
  return [...stats.values()].sort((a, b) => b.games - a.games || b.wins - a.wins);
};
